import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PostBeautifierPage } from "@/components/PostBeautifierPage";
import "./styles/globals.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element was not found.");
}

createRoot(rootElement).render(
  <StrictMode>
    <PostBeautifierPage />
  </StrictMode>,
);
